import { MetricCellBase } from '~/features/metric-cell'
import { useAnalytics } from '~/modules/analytics/hooks/useAnalytics'

import { Timespan, toPercent } from '@hap/utils'

import { useAnalyticsPresets } from '../../-components/hooks'
import { MetricFilters } from '../../-components/metric-widget'

import type { JSX } from "react";

export function AgentsBelowGoal(props: Props): JSX.Element {
  const presets = useAnalyticsPresets({
    filters: props.filters,
    criteriaId: props.criteriaId,
  })
  const { data: belowGoalData, loading } = useAnalytics({
    filters: presets.filters,
    aggregations: {
      agentsBelowGoal: {
        field: 'handledBy',
        dataset: 'interactions',
      },

      score: {
        op: 'avg',
        field: 'score',
        having: {
          op: 'lt',
          value: 0.84,
        },
      },
    },

    timespan: props.timespan,
    dataset: 'evaluationCriteriaScores',
  })

  const { data } = useAnalytics({
    filters: presets.filters,
    aggregations: {
      avgScore: {
        op: 'avg',
        field: 'score',
      },
    },

    timespan: props.timespan,
    dataset: 'evaluationCriteriaScores',
  })

  const { data: data2 } = useAnalytics({
    filters: presets.filters,
    aggregations: {
      totalAgents: {
        op: 'countDistinct',
        field: 'assignedTo',
      },
    },

    timespan: props.timespan,
    dataset: 'evaluations',
  })

  const avgScore = data ? data[0]?.avgScore : null
  const totalAgents = data2 ? parseInt(data2[0]?.totalAgents) : 0

  return (
    <>
      <MetricCellBase label="Avg Score" value={toPercent(avgScore)} loading={loading} />
      <MetricCellBase
        label="# Agents Below Goal"
        value={belowGoalData ? belowGoalData.length : null}
        loading={loading}
      />
      <MetricCellBase
        label="% Agents Below Goal"
        value={belowGoalData ? toPercent(belowGoalData.length / totalAgents) : null}
        loading={loading}
      />
    </>
  )
}

interface Props {
  criteriaId: string
  filters: MetricFilters
  timespan: Timespan.StaticTimespan
}
